(() => {
  if (window.__singlefileBottleLimitDropdownInit) return;
  window.__singlefileBottleLimitDropdownInit = true;

  const routesRoot = window.Shopify?.routes?.root || "/";
  const productQueues = new Map();
  const cardStates = new Map();
  let cartState = readInitialCart();
  let checkoutValidationInProgress = false;

  function route(path) {
    return `${routesRoot}${path}`;
  }

  function positiveInteger(value) {
    const number = Number.parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : null;
  }

  function readInitialCart() {
    const element = document.getElementById(
      "sf-bottle-limit-cart-state",
    );

    if (!element) return null;

    try {
      const parsed = JSON.parse(element.textContent || "{}");
      return Array.isArray(parsed.items) ? parsed : null;
    } catch (error) {
      console.warn(
        "Bottle limit: initial cart state could not be read.",
        error,
      );
      return null;
    }
  }

  async function fetchCart() {
    const response = await fetch(route("cart.js"), {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Unable to load cart (${response.status})`);
    }

    cartState = await response.json();
    return cartState;
  }

  async function ensureCart() {
    return cartState && Array.isArray(cartState.items)
      ? cartState
      : fetchCart();
  }

  function itemsForProduct(cart, productId) {
    if (!cart || !Array.isArray(cart.items)) return [];

    return cart.items.filter(
      (item) =>
        String(item.product_id) === String(productId),
    );
  }

  function productQuantity(cart, productId) {
    return itemsForProduct(cart, productId).reduce(
      (total, item) => total + item.quantity,
      0,
    );
  }

  function lineItem(cart, lineKey) {
    return (
      cart?.items?.find((item) => item.key === lineKey) ||
      null
    );
  }

  function mutationPayload(payload) {
  const drawerSection = document
    .querySelector("cart-drawer#cart-drawer")
    ?.closest(".shopify-section");

  const drawerSectionId = drawerSection?.id?.replace(
    /^shopify-section-/,
    "",
  );

  return {
    ...payload,
    sections: drawerSectionId || "cart-drawer",
    sections_url: window.location.pathname,
  };
}

  async function changeLine(lineKey, quantity) {
    const response = await fetch(route("cart/change.js"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        mutationPayload({
          id: lineKey,
          quantity,
        }),
      ),
    });

    if (!response.ok) {
      throw new Error(
        `Unable to update cart (${response.status})`,
      );
    }

    cartState = await response.json();
    return cartState;
  }

  async function addVariant(variantId, quantity) {
    const response = await fetch(route("cart/add.js"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        mutationPayload({
          items: [
            {
              id: Number(variantId),
              quantity,
            },
          ],
        }),
      ),
    });

    if (!response.ok) {
      throw new Error(
        `Unable to add to cart (${response.status})`,
      );
    }

    const added = await response.json();
    const refreshedCart = await fetchCart();

    if (added.sections) {
      refreshedCart.sections = added.sections;
    }

    return refreshedCart;
  }

  async function setProductQuantity(
    productId,
    variantId,
    desiredQuantity,
  ) {
    let cart = await ensureCart();
    const matchingItems = itemsForProduct(cart, productId);
    const currentQuantity = productQuantity(cart, productId);

    if (desiredQuantity === currentQuantity) {
      return cart;
    }

    if (desiredQuantity > currentQuantity) {
      const increase =
        desiredQuantity - currentQuantity;

      const preferredLine = matchingItems.find(
        (item) =>
          String(item.variant_id) === String(variantId),
      );

      if (preferredLine) {
        return changeLine(
          preferredLine.key,
          preferredLine.quantity + increase,
        );
      }

      return addVariant(variantId, increase);
    }

    let excess = currentQuantity - desiredQuantity;

    const preferredItems = [
      ...matchingItems.filter(
        (item) =>
          String(item.variant_id) === String(variantId),
      ),
      ...matchingItems.filter(
        (item) =>
          String(item.variant_id) !== String(variantId),
      ),
    ];

    for (const item of preferredItems) {
      if (excess <= 0) break;

      const reduction = Math.min(
        item.quantity,
        excess,
      );

      cart = await changeLine(
        item.key,
        item.quantity - reduction,
      );

      excess -= reduction;
    }

    return cart;
  }

  function queueProductTask(productId, task) {
    const id = String(productId);

    const previous =
      productQueues.get(id) || Promise.resolve();

    const next = previous
      .catch(() => {})
      .then(task);

    productQueues.set(id, next);

    next.finally(() => {
      if (productQueues.get(id) === next) {
        productQueues.delete(id);
      }
    });

    return next;
  }

  function replaceCartDrawer(html) {
    if (!html) return;

    const currentDrawer = document.querySelector(
      "cart-drawer#cart-drawer",
    );

    if (!currentDrawer) return;

    const parsed = new DOMParser().parseFromString(
      html,
      "text/html",
    );

    const replacement = parsed.querySelector(
      "cart-drawer#cart-drawer",
    );

    if (replacement) {
      currentDrawer.replaceWith(replacement);
    }
  }

  function publishCart(cart, source = "bottle-limit:update") {
  if (!cart || !Array.isArray(cart.items)) return;

  cartState = cart;
  const baseEvent =
    source === "variant:add" ? "variant:add" : "line-item:change";

  document.dispatchEvent(
    new CustomEvent("cart:change", {
      bubbles: true,
      detail: { cart, baseEvent },
    }),
  );
}

  function rebuildOptions(
    select,
    maximum,
    selected,
  ) {
    const safeMaximum = Math.max(0, maximum);

    const safeSelected = Math.max(
      0,
      Math.min(selected, safeMaximum),
    );

    if (
      select.options.length === safeMaximum + 1 &&
      select.options[
        select.options.length - 1
      ]?.value === String(safeMaximum)
    ) {
      select.value = String(safeSelected);
      return;
    }

    const fragment =
      document.createDocumentFragment();

    for (
      let quantity = 0;
      quantity <= safeMaximum;
      quantity += 1
    ) {
      const option =
        document.createElement("option");

      option.value = String(quantity);
            option.textContent = String(quantity);
      option.selected =
        quantity === safeSelected;

      fragment.appendChild(option);
    }

    select.replaceChildren(fragment);
  }

  function setControlStatus(
    control,
    message = "",
    isError = false,
  ) {
    const status = control.querySelector(
      "[data-bottle-limit-status]",
    );

    if (!status) return;

    status.textContent = message;

    status.classList.toggle(
      "is-error",
      isError,
    );
  }

  function setProductControlsBusy(productId, busy) {
  document
    .querySelectorAll(
      `[data-bottle-limit-control][data-product-id="${CSS.escape(String(productId))}"]`,
    )
    .forEach((control) => {
      control.setAttribute("aria-busy", busy ? "true" : "false");
      control.classList.toggle("is-updating", busy);
    });
}

  function syncBottleLimitControls(cart) {
    document
      .querySelectorAll(
        "[data-bottle-limit-control]",
      )
      .forEach((control) => {
        const select = control.querySelector(
          "[data-bottle-limit-select]",
        );

        const productId =
          control.dataset.productId;

        const lineKey =
          control.dataset.lineKey;

        const limit = positiveInteger(
          control.dataset.bottleLimit,
        );

        const renderedMaximum =
          Number.parseInt(
            control.dataset.maximumQuantity,
            10,
          );

        if (!select || !productId || !limit) {
          return;
        }

        const total = productQuantity(
          cart,
          productId,
        );

        control.dataset.currentTotal =
          String(total);

        if (lineKey) {
          const item = lineItem(cart, lineKey);
          const lineQuantity =
            item?.quantity || 0;

          const otherQuantity = Math.max(
            0,
            total - lineQuantity,
          );

          const maximumForLine = Math.min(
            Math.max(
              0,
              limit - otherQuantity,
            ),
            Number.isFinite(renderedMaximum)
              ? renderedMaximum
              : Number.POSITIVE_INFINITY,
          );

          rebuildOptions(
            select,
            maximumForLine,
            lineQuantity,
          );
        } else {
          const maximumForProduct =
            Number.isFinite(renderedMaximum)
              ? Math.min(
                  limit,
                  renderedMaximum,
                )
              : limit;

          rebuildOptions(
            select,
            maximumForProduct,
            Math.min(
              total,
              maximumForProduct,
            ),
          );
        }
      });
  }

  function setLegacyCardUI(
    productId,
    quantity,
  ) {
    document
      .querySelectorAll(
        `.collection-atc-wrapper[data-product-id="${CSS.escape(
          String(productId),
        )}"]`,
      )
      .forEach((wrapper) => {
        if (
          positiveInteger(
            wrapper.dataset
              .bottlePurchaseLimit,
          )
        ) {
          return;
        }

        const productForm =
          wrapper.querySelector(
            "product-form",
          );

        const quantityBox =
          wrapper.querySelector(
            ".collection-qty",
          );

        const quantityValue =
          wrapper.querySelector(
            ".qty-value",
          );

        if (
          !productForm ||
          !quantityBox ||
          !quantityValue
        ) {
          return;
        }

        productForm.hidden = quantity > 0;

        quantityBox.classList.toggle(
          "hidden",
          quantity <= 0,
        );

        quantityValue.textContent =
          String(Math.max(0, quantity));
      });
  }

  function syncLegacyCardControls(cart) {
    const productIds = new Set(
      [
        ...document.querySelectorAll(
          ".collection-atc-wrapper[data-product-id]",
        ),
      ]
        .map(
          (wrapper) =>
            wrapper.dataset.productId,
        )
        .filter(Boolean),
    );

    productIds.forEach((productId) => {
      const pending = cardStates.get(
        String(productId),
      );

      const quantity = pending?.running
        ? pending.desired
        : productQuantity(
            cart,
            productId,
          );

      setLegacyCardUI(
        productId,
        quantity,
      );
    });
  }

  function knownLimits() {
    const limits = new Map();

    document
      .querySelectorAll(
        "[data-bottle-limit-control], [data-product-id][data-bottle-purchase-limit]",
      )
      .forEach((element) => {
        const productId =
          element.dataset.productId;

        const limit = positiveInteger(
          element.dataset.bottleLimit ||
            element.dataset
              .bottlePurchaseLimit,
        );

        if (productId && limit) {
          limits.set(
            String(productId),
            limit,
          );
        }
      });

    return limits;
  }

  function syncAcceleratedCheckout(cart) {
    const limits = knownLimits();

    const hasLimitedProduct = [
      ...limits.keys(),
    ].some(
      (productId) =>
        productQuantity(
          cart,
          productId,
        ) > 0,
    );

    document.documentElement.classList.toggle(
      "sf-cart-has-limited-product",
      hasLimitedProduct,
    );
  }

  function syncAllControls(cart) {
    syncBottleLimitControls(cart);
    syncLegacyCardControls(cart);
    syncAcceleratedCheckout(cart);
  }

  async function handleLimitedSelect(select) {
    const control = select.closest(
      "[data-bottle-limit-control]",
    );

    if (!control) return;

    const productId =
      control.dataset.productId;

    const variantId =
      control.dataset.variantId;

    const lineKey =
      control.dataset.lineKey;

    const limit = positiveInteger(
      control.dataset.bottleLimit,
    );

    const renderedMaximum =
      Number.parseInt(
        control.dataset.maximumQuantity,
        10,
      );

    const desired = Number.parseInt(
      select.value,
      10,
    );

    if (
      !productId ||
      !variantId ||
      !limit ||
      !Number.isFinite(desired)
    ) {
      return;
    }

    setControlStatus(control);
    setProductControlsBusy(productId, true);

    try {
      const updatedCart =
        await queueProductTask(
          productId,
          async () => {
            const freshCart =
              await ensureCart();

            if (lineKey) {
              const item = lineItem(
                freshCart,
                lineKey,
              );

              if (!item) return freshCart;

              const total = productQuantity(
                freshCart,
                productId,
              );

              const otherQuantity =
                Math.max(
                  0,
                  total - item.quantity,
                );

              const maximumForLine =
                Math.min(
                  Math.max(
                    0,
                    limit - otherQuantity,
                  ),
                  Number.isFinite(
                    renderedMaximum,
                  )
                    ? renderedMaximum
                    : Number.POSITIVE_INFINITY,
                );

              return changeLine(
                lineKey,
                Math.max(
                  0,
                  Math.min(
                    desired,
                    maximumForLine,
                  ),
                ),
              );
            }

            return setProductQuantity(
              productId,
              variantId,
              Math.max(
                0,
                Math.min(
                  desired,
                  limit,
                  Number.isFinite(
                    renderedMaximum,
                  )
                    ? renderedMaximum
                    : Number.POSITIVE_INFINITY,
                ),
              ),
            );
          },
        );

      publishCart(updatedCart);

      setControlStatus(control);

    } catch (error) {
      console.error(
        "Bottle limit quantity update failed:",
        error,
      );

      setControlStatus(
        control,
        "We couldn't update your cart. Please try again.",
        true,
      );

      try {
        syncAllControls(
          await fetchCart(),
        );
      } catch (refreshError) {
        console.error(
          "Bottle limit cart refresh failed:",
          refreshError,
        );
      }
    } finally {
      setProductControlsBusy(
        productId,
        false,
      );
    }
  }

  function scheduleLegacyCardUpdate(
    wrapper,
    direction,
  ) {
    const productId =
      wrapper.dataset.productId;

    const variantId =
      wrapper.querySelector(
        'input[name="id"]',
      )?.value;

    if (!productId || !variantId) return;

    const id = String(productId);

    const actualQuantity =
      productQuantity(cartState, id);

    const state =
      cardStates.get(id) || {
        desired: actualQuantity,
        running: false,
        timer: null,
        variantId,
      };

    state.variantId = variantId;

    state.desired = Math.max(
      0,
      state.desired +
        (direction === "plus" ? 1 : -1),
    );

    if (state.timer) {
      window.clearTimeout(state.timer);
    }

    state.timer = window.setTimeout(
      () => flushLegacyCardUpdate(id),
      160,
    );

    cardStates.set(id, state);

    setLegacyCardUI(
      id,
      state.desired,
    );
  }

  async function flushLegacyCardUpdate(
    productId,
  ) {
    const state =
      cardStates.get(productId);

    if (!state || state.running) return;

    state.running = true;
    state.timer = null;

    const targetQuantity =
      state.desired;

    try {
      const updatedCart =
        await queueProductTask(
          productId,
          () =>
            setProductQuantity(
              productId,
              state.variantId,
              targetQuantity,
            ),
        );

      publishCart(
        updatedCart,
        "collection-quantity:update",
      );
    } catch (error) {
      console.error(
        "Collection quantity update failed:",
        error,
      );

      try {
        cartState = await fetchCart();
      } catch (refreshError) {
        console.error(
          "Collection cart refresh failed:",
          refreshError,
        );
      }
    } finally {
      state.running = false;

      const actualQuantity =
        productQuantity(
          cartState,
          productId,
        );

      if (
        state.desired !== actualQuantity
      ) {
        state.timer = window.setTimeout(
          () =>
            flushLegacyCardUpdate(
              productId,
            ),
          0,
        );
      } else {
        cardStates.delete(productId);
        syncAllControls(cartState);
      }
    }
  }

  function checkoutMessageContainer(
    control,
  ) {
    return (
      control.closest(
        ".main-cart__checkout-area, .cart-drawer__footer, form",
      ) || control.parentElement
    );
  }

  function showCheckoutMessage(
    control,
    text,
    isError = false,
  ) {
    const container =
      checkoutMessageContainer(control);

    if (!container) return;

    let message = container.querySelector(
      ".sf-bottle-limit-checkout-message",
    );

    if (!message) {
      message =
        document.createElement("p");

      message.className =
        "sf-bottle-limit-checkout-message";

      message.setAttribute(
        "role",
        "alert",
      );

      container.prepend(message);
    }

    message.textContent = text;

    message.classList.toggle(
      "is-error",
      isError,
    );
  }

  async function repairViolation(
    cart,
    productId,
    limit,
  ) {
    let workingCart = cart;

    let excess =
      productQuantity(
        workingCart,
        productId,
      ) - limit;

    const matchingItems = [
      ...itemsForProduct(
        workingCart,
        productId,
      ),
    ].reverse();

    for (const item of matchingItems) {
      if (excess <= 0) break;

      const reduction = Math.min(
        item.quantity,
        excess,
      );

      workingCart = await changeLine(
        item.key,
        item.quantity - reduction,
      );

      excess -= reduction;
    }

    return workingCart;
  }

  async function validateCheckout(
    event,
    control,
  ) {
    const limits = knownLimits();

    if (!limits.size) return;

    event.preventDefault();
    event.stopPropagation();

    if (checkoutValidationInProgress) {
      return;
    }

    checkoutValidationInProgress = true;

    control.setAttribute(
      "aria-busy",
      "true",
    );

    try {
      let freshCart = await fetchCart();
      const violations = [];

      for (
        const [productId, limit]
        of limits.entries()
      ) {
        const quantity =
          productQuantity(
            freshCart,
            productId,
          );

        if (quantity > limit) {
          violations.push({
            productId,
            limit,
            quantity,
          });

          freshCart =
            await repairViolation(
              freshCart,
              productId,
              limit,
            );
        }
      }

      if (violations.length) {
        publishCart(
          freshCart,
          "bottle-limit:repair",
        );

        showCheckoutMessage(
          control,
          "A limited product exceeded its maximum, so its quantity was corrected. Please review your cart before checking out.",
          true,
        );

        return;
      }

      const checkoutUrl =
        control instanceof
          HTMLAnchorElement &&
        control.href
          ? control.href
          : route("checkout");

      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error(
        "Bottle limit checkout validation failed:",
        error,
      );

      showCheckoutMessage(
        control,
        "We couldn't verify the bottle limit. Please try again.",
        true,
      );
    } finally {
      checkoutValidationInProgress = false;

      control.removeAttribute(
        "aria-busy",
      );
    }
  }

  document.addEventListener(
    "change",
    (event) => {
      const select =
        event.target.closest?.(
          "[data-bottle-limit-select]",
        );

      if (select) {
        handleLimitedSelect(select);
      }
    },
  );

  document.addEventListener(
    "click",
    (event) => {
      const quantityButton =
        event.target.closest?.(
          ".collection-atc-wrapper .collection-qty .qty-btn",
        );

      if (quantityButton) {
        const wrapper =
          quantityButton.closest(
            ".collection-atc-wrapper",
          );

        if (
          wrapper &&
          !positiveInteger(
            wrapper.dataset
              .bottlePurchaseLimit,
          )
        ) {
          event.preventDefault();

          scheduleLegacyCardUpdate(
            wrapper,
            quantityButton.classList.contains(
              "qty-plus",
            )
              ? "plus"
              : "minus",
          );
        }

        return;
      }

      const checkoutControl =
        event.target.closest?.(
          'a[href*="/checkout"], button[name="checkout"], input[name="checkout"]',
        );

      if (checkoutControl) {
        validateCheckout(
          event,
          checkoutControl,
        );
      }
    },
    true,
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;

      if (
        !(form instanceof HTMLFormElement)
      ) {
        return;
      }

      const checkoutControl =
        event.submitter ||
        form.querySelector(
          'button[name="checkout"], input[name="checkout"]',
        );

      if (
        checkoutControl &&
        (
          form.matches(
            'form[action*="/checkout"]',
          ) ||
          checkoutControl.getAttribute(
            "name",
          ) === "checkout"
        )
      ) {
        validateCheckout(
          event,
          checkoutControl,
        );
      }
    },
    true,
  );

  document.addEventListener(
    "cart:change",
    (event) => {
      const changedCart =
        event.detail?.cart;

      if (
        changedCart &&
        Array.isArray(changedCart.items)
      ) {
        cartState = changedCart;
        syncAllControls(changedCart);
      }
    },
  );

  if (cartState) {
    syncAllControls(cartState);
  }
})();